import React from "react";
import { InPageEditableSectionField, Section, TwoColumnInPageEditableSectionField } from "../types";

/**
 * Turns an array of Sections into an array of InPageEditableSectionFields suitable for use in a SidePanelDetailSectionTemplate
 * Constraints:
 *  - Custom sections are not supported
 * The following rules apply:
 *  - Section headers get turned into a new field
 *  - First section header is ignored   
 */
export const convertSectionsToSidePanel = (
  sections: Array<Section>
): Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField> => {
  const result: Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField> = [];

  sections.filter(section => section.type !== "custom").forEach((section, sectionIndex) => {
    // Ignore first section header
    if (sectionIndex !== 0) {
      result.push({
        key: `section-${section.key}`,
        label: "",
        hideLabel: true,
        render: () => <h3>{section.title}</h3>
      });
    }

    section.fields.forEach(field => {
      result.push(field);
    });
  });

  return result;
}

/**
 * Flattens TwoColumnInPageEditableSectionFields into individual InPageEditableSectionFields
 */
export const flattenTwoColumnFields = (
  fields: Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField>
): Array<InPageEditableSectionField> => {
  const result: Array<InPageEditableSectionField> = [];

  let rightColumnBuffer: Array<InPageEditableSectionField> = [];
  fields.forEach(field => {
    const isTwoColumnField = "left" in field && "right" in field;

    if (isTwoColumnField) {
      // If this is a two column field, we add the left column now, and buffer the right column
      result.push({
        label: field.label,
        ...field.left,
        key: field.left.key,
      });
      rightColumnBuffer.push({
        label: field.label,
        ...field.right,
        key: field.right.key,
      });
    } else {
      // If we have a buffer, we push it to the result.
      if (rightColumnBuffer.length > 0) {
        rightColumnBuffer.forEach(bufferedField => {
          result.push(bufferedField);
        });
        rightColumnBuffer = [];
      }

      result.push(field);
    }
  });

  if (rightColumnBuffer.length > 0) {
    rightColumnBuffer.forEach(bufferedField => {
      result.push(bufferedField);
    });
  }

  return result;
}